/**
 * Sorteerrichting van het evenementenoverzicht op status. Moet exact overeenkomen
 * met de waarden van `statusOrder` in apps/safezone-api/src/schemas/case.schema.ts.
 */
export type StatusOrder = 'expired-first' | 'open-first';

export const DEFAULT_STATUS_ORDER: StatusOrder = 'expired-first';

export interface StatusOrderOption {
  value: StatusOrder;
  label: string;
}

export const statusOrderOptions: StatusOrderOption[] = [
  { value: 'expired-first', label: 'Verlopen → Open' },
  { value: 'open-first', label: 'Open → Verlopen' },
];

export function statusOrderTriggerLabel(value: StatusOrder): string {
  return statusOrderOptions.find((option) => option.value === value)!.label;
}
